import { ColumnConfig } from '@/components/table/Table';
import {
  renderAuth,
  renderLastRunHttpCode,
  renderLastRunStatus,
  renderStatus,
  renderTime,
} from '../renderers';
import { COUNTRY, COUNTRY_LABEL } from '@/config/country';

export const tasksListColumns: ColumnConfig[] = [
  {
    label: 'Estado de tarea',
    field: 'status',
    render: renderStatus,
  },
  {
    label: 'Nombre',
    field: 'name',
  },
  {
    label: 'Cron expresión',
    field: 'cronExpression',
  },
  {
    label: 'Método',
    field: 'method',
  },
  {
    label: 'URL',
    field: 'url',
  },
  {
    label: 'Auth',
    field: 'authRequired',
    render: renderAuth,
  },
  {
    label: `Próx. Ejecución (hora de ${COUNTRY_LABEL[COUNTRY]})`,
    field: 'nextRunAt',
    render: renderTime,
  },
  {
    label: `Última ejecución (hora de ${COUNTRY_LABEL[COUNTRY]})`,
    field: 'lastRunAt',
    render: renderTime,
  },
  {
    label: 'Última ejecución estado',
    field: 'lastRunStatus',
    render: renderLastRunStatus,
  },
  {
    label: 'Último estado HTTP',
    field: 'lastRunHttpCode',
    render: renderLastRunHttpCode,
  },
];
